import { useEffect, useState } from "react";
import { ManagedWindow, WindowState } from "src/WindowManager/WindowState";
import { MitWebsocket, ServerMessages } from "src/common/managers/MitWebsocket";
import { AdvancedDragModal, ADModalBody, ADModalFooter } from "src/componentsUtils/AdvancedDragModal";
import { GlassInputControl } from "./GlassInput";

export function ChatWindow(props: { window: ManagedWindow, onClose: () => void }) {
   const [msg, setMsg] = useState<{ sender: string, msg: string }[]>([])


   useEffect(() => {
      const callback = (message: ServerMessages) => {
         if (message.type === "members") {
            setMsg(message.action.members.map((m) => { return { sender: "System", msg: m + " online" } }))
         }
      }
      MitWebsocket.subscribe("ping", callback);
      return () => {
         MitWebsocket.unsubscribe("ping", callback);
      }
   }, [])

   if (props.window.state !== WindowState.Open) {
      return null
   }


   return (
      <AdvancedDragModal title="Chat" window={props.window} onClose={props.onClose}
         PosDefault={{ left: "97%", top: "40px", height: "50%", transform: "translate(-97%, 0)" }}
      >
         <ADModalBody>
            <div >
               {msg.map((m, i) => {
                  return <div key={i}>{m.sender}: {m.msg}</div>
               })}
            </div>
         </ADModalBody>
         <ADModalFooter>
            <GlassInputControl>
               <input type="text" onKeyDown={(e) => {
                  if (e.key == "Enter" && e.currentTarget.value && e.currentTarget.value.trim() != "") {
                     let msg = e.currentTarget.value;
                     MitWebsocket.send({ type: "sendToChannel", action: { channel: "chat", data: { message: msg } } })
                     setMsg((oldMsg) => [...oldMsg, { sender: "me", msg: msg }])
                     e.currentTarget.value = ""
                  }
               }} ></input>
            </GlassInputControl>
         </ADModalFooter>

      </AdvancedDragModal>



   )

}